import { useQuery } from '@tanstack/react-query';
import invariant from 'tiny-invariant';

import { Search } from '@air/api';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';

const getPrivateVideoAspectRatiosListKey = ({
  workspaceId,
  search,
  boardId,
  libraryId,
}: {
  workspaceId: string | undefined;
  search: string;
  boardId: string | undefined;
  libraryId: string | undefined;
}) => ['PRIVATE_VIDEO_ASPECT_RATIO_FORMATS', { workspaceId, search, boardId, libraryId }];

export const usePrivateVideoAspectRatiosList = ({
  search,
  boardId,
  libraryId,
}: {
  search: string;
  boardId: string | undefined;
  libraryId: string | undefined;
}) => {
  const { currentWorkspace } = useCurrentWorkspace();

  const key = getPrivateVideoAspectRatiosListKey({ workspaceId: currentWorkspace?.id, search, boardId, libraryId });

  return useQuery({
    queryKey: key,

    queryFn: async () => {
      invariant(currentWorkspace?.id, 'Workspace ID is required');

      const data = await Search.getAssetVersionFilterLookups({
        limit: 10,
        search,
        workspaceId: currentWorkspace.id,
        field: 'videoAspectRatio',
        boardId,
        libraryId,
      });

      return data.lookups.map(({ value }) => value.toString());
    },
    enabled: !!currentWorkspace?.id,
  });
};
